import ImageGrid from './ImageGridView'


export default ImageGrid
